/** JID de grupo do WhatsApp termina em @g.us (ex.: 120363...@g.us). */
export function isLikelyWhatsappGroupJid(phoneOrJid) {
  return /@g\.us\b/i.test(String(phoneOrJid || "").trim());
}
